<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">人员名称:</div>
                <el-input v-model="conditionData.Name" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">手机:</div>
                <el-input v-model="conditionData.Phone" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">搜索</el-button>
                <el-button type="warning" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <el-button type="primary" icon="el-icon-circle-plus" size="small" @click="addDialogShow()">新建</el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column
                type="selection"
                width="80"
                align="center"
                >
                </el-table-column>
                <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="name"
                label="用户名称"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="phone"
                label="手机"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="roleName"
                label="角色名称"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="mechanismName"
                label="机构名称"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="enable"
                label="是否启用"
                align="center"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.enable">启用</span>
                    <span v-else>禁用</span>
                </template>
                </el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="100px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-edit" size="mini" @click="isUpdateDialogShow(scope.row)">编辑</el-button>
                    <!-- <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteUser(scope.row)">删除</el-button> -->
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next"
                    :total="totalCount"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
                
            </div>
        </div>


        <el-dialog :visible.sync="isAddDialog" title="新增用户" width="800px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        用户名称:
                    </div>
                    <div class="input">
                        <el-input v-model="addData.name" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        手机号:
                    </div>
                    
                    <div class="input">
                        <el-input v-model="addData.phone" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        密码:
                    </div>
                    <div class="input">
                        <el-input v-model="addData.password" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                
                <div class="item">
                    <div class="label">
                        角色:
                    </div>
                    <div class="input">
                        <el-input v-model="role" size="small" placeholder="请选择"></el-input>
                        <el-button type="primary" size="small" @click="roleDialog = true">选择角色</el-button>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        机构:
                    </div>
                    <div class="input">
                        <el-input v-model="organization" size="small" placeholder="请选择"></el-input>
                        <el-button type="primary" size="small" @click="organizationDialog=true">选择机构</el-button>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        创建人:
                    </div>
                    <div class="input">
                        <el-input v-model="addData.creator" size="small" placeholder="请输入"></el-input>
                    </div>
                </div> -->
                <div class="item">
                    <div class="label">
                        是否启用:
                    </div>
                    <el-select v-model="addData.enable" placeholder="请选择" size="small">
                        <el-option
                        v-for="item in enableList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="btns">
                    <el-button type="primary" icon="el-icon-check" size="small" @click="addUser">提交</el-button>
                </div>
            </div>
        </el-dialog>
        
        <el-dialog :visible.sync="isUpdateDialog" title="编辑用户" width="800px">
            <div class="dialog">
                <div class="item">
                    <div class="label">
                        用户名称:
                    </div>
                    <div class="input">
                        <el-input v-model="updateData.name" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        手机号:
                    </div>
                    <div class="input">
                        <el-input v-model="updateData.phone" size="small" placeholder="请输入"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        密码:
                    </div>
                    <div class="input">
                        <el-input v-model="updateData.password" size="small" placeholder="不修改密码请不要填写"></el-input>
                    </div>
                </div>
                
                <div class="item">
                    <div class="label">
                        角色:
                    </div>
                    <div class="input">
                        <el-input v-model="role" size="small" placeholder="请选择"></el-input>
                        <el-button type="primary" size="small" @click="roleDialog = true">选择角色</el-button>
                    </div>
                </div>
                <div class="item">
                    <div class="label">
                        机构:
                    </div>
                    <div class="input">
                        <el-input v-model="organization" size="small" placeholder="请选择"></el-input>
                        <el-button type="primary" size="small" @click="organizationDialog=true">选择机构</el-button>
                    </div>
                </div>
                <!-- <div class="item">
                    <div class="label">
                        创建人:
                    </div>
                    <div class="input">
                        <el-input v-model="updateData.creator" size="small" placeholder="请输入"></el-input>
                    </div>
                </div> -->
                <div class="item">
                    <div class="label">
                        是否启用:
                    </div>
                    <el-select v-model="updateData.enable" placeholder="请选择" size="small">
                        <el-option
                        v-for="item in enableList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="btns">
                    <el-button type="primary" icon="el-icon-check" size="small" @click="updateUser">提交</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="roleDialog" title="角色选择" width="800px">
            <div class="table">
                <el-table
                    :data="roleList"
                    border
                    :header-cell-style="tableHeaderColor"
                    style="width: 100%">
                    <el-table-column
                    prop="name"
                    label="角色名称"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="code"
                    label="角色编码"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    fixed="right"
                    label="操作"
                    width="120px"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="selectRole(scope.row)">选择角色</el-button>
                    </template>
                    </el-table-column>
                </el-table>
                <div class="page">
                    <el-pagination
                    @current-change="handleRolePageChange"
                        background
                        layout="prev, pager, next"
                        :total="roleTotalCount"
                        :current-page="rolePage"
                        :page-size="rolePageSize">
                    </el-pagination>
                </div>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="organizationDialog" title="机构选择" width="800px">
            <div class="table">
                <el-table
                    :data="organizationList"
                    border
                    :header-cell-style="tableHeaderColor"
                    style="width: 100%">
                    <el-table-column
                    prop="name"
                    label="机构名称"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="province"
                    label="所属省份"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="city"
                    label="所属市级"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    prop="area"
                    label="所属片区"
                    align="center"
                    >
                    </el-table-column>
                    <el-table-column
                    fixed="right"
                    label="操作"
                    width="120px"
                    align="center"
                    >
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="selectOrganization(scope.row)">选择机构</el-button>
                    </template>
                    </el-table-column>
                </el-table>
                <div class="page">
                    <el-pagination
                    @current-change="handleOrganizationPageChange"
                        background
                        layout="prev, pager, next"
                        :total="organizationTotalCount"
                        :current-page="organizationPage"
                        :page-size="organizationPageSize">
                    </el-pagination>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import api from '../../../api/main'
export default {
    name: 'person',
    data () {
        return {
            gandenList:[
                {
                    value:'1',
                    label:'男'
                }
            ],
            enableList:[
                {
                    value:true,
                    label:'启用'
                },{
                    value:false,
                    label:'禁用'
                }
            ],
            isShow:false,
            totalCount:0,
            isUpdateDialog:false,
            updateData:{}, 
            conditionData:{
                Name:'',
                Phone:'',
                page:1,
                pageSize:10,
            },
            tableData:[],
            isAddDialog:false,
            addData:{
                ganden:2,
            },
            role:'',
            roleList:[],
            rolePage:1,
            rolePageSize:10,
            roleDialog:false,
            roleTotalCount:0,

            organization:'',
            organizationList:[],
            organizationPage:1,
            organizationPageSize:10,
            organizationDialog:false,
            organizationTotalCount:0,
        }
    },
    created(){

    },
    mounted(){
        this.loadingData();
        this.queryRole();
        this.queryOrganization();
    },
    methods:{
        
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            let res  = await api.QueryUsers(this.conditionData);
            console.log(res);
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
        },
        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        selectRole(row){
            this.role = row.name
            this.roleDialog = false;
            if(this.isAddDialog){
                this.addData.roleId = row.id
            }else if(this.isUpdateDialog){
                this.updateData.roleId = row.id
            }
        },
        selectOrganization(row){
            console.log(row);
            this.organization = row.name
            this.organizationDialog = false;
            if(this.isAddDialog){
                this.addData.mechanismId = row.id
            }else if(this.isUpdateDialog){
                this.updateData.mechanismId = row.id
            }
        },
        handleRolePageChange(page){
            this.rolePage = page;
            this.queryRole();
        },
        handleOrganizationPageChange(page){
            this.organizationPage = page;
            this.queryOrganization();
        },
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        isUpdateDialogShow(row){
            this.organization = row.mechanismName;
            this.role = row.roleName;
            this.updateData = row;
            this.isUpdateDialog = true;
        },
        // 重置
        reset(){
            this.conditionData = {
                name:'',
                page: 1,
                pageSize: 10,
            },
            this.loadingData();
        },
        // 弹出新建
        addDialogShow(){
            this.addData={};
            this.organization='';
            this.role='';
            this.isAddDialog = true;
        },
        // 添加用户
        async addUser(){
            
            if(!this.addData.name){
                this.$message({
                    type: 'warning',
                    message: '请填写用户名!'
                });
                return;
            }
            if(!this.addData.phone){
                this.$message({
                    type: 'warning',
                    message: '请填写手机号!'
                });
                return;
            }
            if(!this.addData.roleId){
                this.$message({
                    type: 'warning',
                    message: '请选择角色!'
                });
                return;
            }
            if(!this.addData.mechanismId){
                this.$message({
                    type: 'warning',
                    message: '请选择机构!'
                });
                return;
            }
            
            let res  = await api.CreateUser(this.addData);
            if(res.data.code == '200'){
                this.isAddDialog = false;
                this.$message({
                    type: 'success',
                    message: '新增成功!'
                });
                this.selectData();
            }
        },
        // 新增用户
        async updateUser(){
            if(!this.updateData.name){
                this.$message({
                    type: 'warning',
                    message: '请填写用户名!'
                });
                return;
            }
            if(!this.updateData.phone){
                this.$message({
                    type: 'warning',
                    message: '请填写手机号!'
                });
                return;
            }
            if(!this.updateData.roleId){
                this.$message({
                    type: 'warning',
                    message: '请选择角色!'
                });
                return;
            }
            if(!this.updateData.mechanismId){
                this.$message({
                    type: 'warning',
                    message: '请选择机构!'
                });
                return;
            }
            let res  = await api.UpdateUser(this.updateData);
            if(res.data.code == '200'){
                this.isUpdateDialog = false;
                this.$message({
                    type: 'success',
                    message: '更新成功!'
                });
                this.selectData();
            }
        },
        // 角色列表
        async queryRole(){
            let res  = await api.QueryRole({page:this.rolePage, pageSize:10});
            console.log(res);
            this.roleList = res.data.data.data;
            this.roleTotalCount = res.data.data.totalCount;
        },
        // 机构列表
        async queryOrganization(){
            let res  = await api.QueryMechanism({page:this.organizationPage, pageSize:10});
            console.log(res);
            this.organizationList = res.data.data.data;
            this.organizationTotalCount = res.data.data.totalCount;
        },
        // 删除角色
        deleteUser(row){
            console.log(row);
            let _this = this;
            this.$confirm('将删除选中的用户, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                _this.deleteAsyncU(row.id);
                
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        async deleteAsyncU(id){
            let res = await api.DeleteAsyncU(id);
            if(res.code == '200'){
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                this.selectData();
            }
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            margin-right: 20px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
    .dialog{
        display: flex;
        flex-direction: column;
        padding-top: 16px;
        height: 100%;
        // overflow: scroll;
        .item{
            font-size: 14px;
            padding:8px 15px;
            display: flex;
            align-items: center;
            .label{
                width: 120px;
                margin-bottom: 5px;
            }
            .input{
                width: 215px;
                display: flex;
            }
        }
        .btns{
            background-color: #ffffff;
            width: 100%;
            bottom: 0;
            display:flex;
            flex-direction: row-reverse;
            .el-button{
                margin-right: 10px;
            }
        }
    }
</style>
